import { c as _c } from "react/compiler-runtime";
import SvgLink from '@common/icon/SvgLink';
import SvgYoutube from '@common/icon/SvgYoutube';
import type { Channel } from '../../_utils/types';
import { ChannelMark } from '../link-card/ChannelMark';
export const ChannelOptionIcon = t0 => {
  const $ = _c(4);
  const {
    channel
  } = t0;
  if (channel === "NAVER_BLOG" || channel === "INSTAGRAM") {
    let t1;
    if ($[0] !== channel) {
      t1 = <ChannelMark channel={channel} />;
      $[0] = channel;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  if (channel === "YOUTUBE") {
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <SvgYoutube aria-hidden={true} className="size-18 shrink-0 text-R-500" />;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    return t1;
  }
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span aria-hidden={true} className="flex size-18 shrink-0 items-center justify-center rounded-xxsmall bg-Gray-50"><SvgLink className="size-11 text-Gray-600" /></span>;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};